// TODO: Eliminar este componente si no se usa
import React from "react";
import { Select, Row, Col, Avatar, Form, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import "./PeopleSelect.scss";

const { Text, Title } = Typography;

const PeopleSelect = ({
  showSearch,
  allowClear,
  mode,
  name,
  label,
  rules,
  usersList
}) => {

  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
    >
      <Select
        showSearch={showSearch}
        allowClear={allowClear}
        mode={mode}
        optionFilterProp="children"
        filterOption={(input, option) =>{
          return option.title.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            .indexOf(input.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")) >= 0
          }
        }
        size="large"
      >
        {usersList.map((item) => (
          <Select.Option
            key={item.token}
            value={item.token}
            title={`${item.name} ${item.last_name}`}
            className="people-people-select-select-option"
          >
            <Row className="people-people-option-select-option-base-card">
              <Col>
                <Avatar
                  src={item.get_avatar || <UserOutlined />}
                  size={30}
                  className="people-people-option-select-option-avatar"
                />
              </Col>
              <Col>
                <Row>
                  <Title className="people-people-option-select-option-title">
                    {`${item.name} ${item.last_name}`}
                  </Title>
                </Row>
                <Row>
                  <Text className="people-people-option-select-option-paragraph">
                    {`${item.position || "Sin cargo"} - ${item.area || "Sin área"}`}
                  </Text>
                </Row>
              </Col>
            </Row>
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default PeopleSelect;
